import ChannelCircle from "./ChannelCircle";
import ColorCircles from "./ChannelDropdown";
import O from "./O";
import React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
    fontSize:12,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      fontSize:12,
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      transform:'translateY(100%)',
    },
  },
};



export default function MultipleSelect({value=[],onChange,options=[]}) {
  const classes = useStyles();

  const handleChangeMultiple = (event) => {
    const { options } = event.target;
    const newValue = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        newValue.push(options[i].value);
      }
    }
    onChange?.(newValue);
  };


  const renderValue = (selected) => (
    <div onClick={e => e.stopPropagation} style={{ 
      transform:'translsate(0,100%)',
      }}>
      {value.map(channelId => {
        let label = options.find(opt => opt.value === channelId)?.label || "WARNING NO LABEL";

          return <div style={{fontSize:12}}>{label}</div>
      })}
    </div>
  )

  /*
   WARNING:
   This would get HIDDEN if the modal z-index is too high.
   You can see the z-index required by looking at what
   MUI renders as default for z-index of the popover.
  */

  const cSize = 16;
  return (
    <div onClick={e => e.stopPropagation()} style={{fontSize:10}} class="">
      <FormControl className={classes.formControl}>
        <Select
          multiple={true}
          value={value}
          onChange={onChange}
          input={<Input />}
          renderValue={renderValue}
          MenuProps={MenuProps}
        >
          {options.map((opt) => (
            <MenuItem style={{
              padding:0,
              paddingRight:10,
              margin:0,
            }} key={opt} value={opt.value}>
              {true && (<><Checkbox checked={value.includes(opt.value)}/>
              <ListItemText style={{
              }} primary={opt.label} />
              </>)}
              <ChannelCircle {...{size:cSize, color:opt.colors?.[0]}}/>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

    </div>
  );
}

